import { useState,useEffect } from "react";
import AxiosFetchData from "../pages/AxiosFetchData";
import { useNavigate, useParams } from 'react-router-dom';
import ConfirmationButton from '../components/ConfirmationButton';
import axios from 'axios';
import {apiUrl} from '../pages/UrlParam'; 
import MainPrint from '../pages/MainPrint.js';
import RetentionPrint from '../pages/RetentionPrint.js';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Helper from "../pages/Helper.js";
import FormControl from '@mui/material/FormControl';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Bindcomponent from "../utils/bindcomponent.js";
export const useInvoicesListHook = (id) =>{
      const [name, setName] = useState('#Inv 1');
      const Navigate = useNavigate();
      const [rows, setRows] = useState([]);
      const [rowsSplit, setRowsSplit] = useState([]);
      const [rowNumber, setRowNumber] = useState([]);
      const [statusList, setStatusList] = useState([]);
      const [print, setPrint] = useState(false);
      const [productList, setProductList] = useState([]);
      const [paymentOpen, setPaymentOpen] = useState(false);
      const [content, setContent] = useState('');
      const [dataInvoice, setDataInvoice] = useState({});
      const [html, setHtml] = useState('');
      const [total, setTotal] = useState(0);
      const [customer, setCustomer] = useState([]);
      const [tipe, setTipe] = useState('');
      const [anchorEl, setAnchorEl] = useState(null);
      const [selectedData, setSelectedData] = useState({});
      const open = Boolean(anchorEl);
      const [message, setmessage] = useState('');
      const [openRetention, setOpenRetention] = useState(false);
      const [openSplit, setOpenSplit] = useState(false);
     
      const [period, setPeriod] = useState('');
      const [retensi, setRetensi] = useState('');
      const [ret, setRet] = useState(0);
      const [periodNumber, setPeriodNumber] = useState(0);
      const [splitInvTotal, setsplitInvTotal] = useState(1);
      const [isNullRetention, setIsNullRetention] = useState(false);
      const [roleAccess, setRoleAccess] = useState('');
      const [productopen, setproductopen] = useState(false);
      const [invoiceId, setInvoiceId] = useState(null);
      const [projectList, setProjectList] = useState([]);
      const [selectedOptionProject,setSelectedOptionProject] = useState('');
      
      const [totalPo, setTotalPo] = useState(null);
      const [invSplitId, setInvSplitId] = useState(null);
      const [errorType, setErrorType] = useState('');

      const handleClick = (event,data) => {
        setSelectedData(data)
        setAnchorEl(event.currentTarget);
      };
    
      const handleClose = () => {
        setAnchorEl(null);
      };

        var result = "";
        var nbsp = "&nbsp;"
        var totalInvoice = 0;

        var mainPrint = new MainPrint(id);

         useEffect(() => {
            //alert(id)
            async function fetchRetention() {
              let response = await GetRetention();
              if(response){
                if(response.data == null){
                  if(id!="00000000000000"){
                    setIsNullRetention(true)
                    setOpenRetention(true);
                  } 
                }
              }
            }
         
            GetProjectList();
            fetchRetention();
            GetStatus();
            Promise.all([fetchData()]);
            setErrorType('')
          }, [id]); 

    function GetProjectList(){
        axios.get(`${apiUrl}/api/GetAllListPO`)
        .then((response) => {
          setSelectedOptionProject(id)
          InitialSplitInvoice(response.data.filter(item => item.id === id).length > 0 ? response.data.filter(item => item.id === id)[0].totalpo : 0)
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
      
      }

      function handleSelectedProject(option){
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('ReturnUrl');
        if(myParam){
          Navigate(`/InvoiceListV3/${option.value}?ReturnUrl=${myParam}`)
        }else{
          Navigate(`/InvoiceListV3/${option.value}`)
        }
  }

  function InitialSplitInvoice(total){
      if(id!="00000000000000"){
          setTotalPo(total)
          Promise.all([AxiosFetchData.get(`IsExistSplitInvoice/${id}`).refreshToken(Navigate,"invoice")]).then(responses => {
              responses.map(response => {
                  if(response.data.length == 0){
                      Promise.all([AddSplitInvoice(id, total)]).then(responses => {
                          InitialSplitInvoice(total)
                      })
                  }else{
                      const rowsWithRowNumbers = response.data.map((row, index) => ({
                          ...row,
                          rowNumber: "#" + (index + 1), 
                      }));
                      setRowsSplit(rowsWithRowNumbers);
                  }     
              });
            });
  
            return;
       } 
      
       setRowsSplit([])
    }

    const GetRetention = async function (projectId=null) {
        try {
            const response = await AxiosFetchData.get(`GetRetention/${projectId == null ? id : projectId}`).refreshToken(Navigate,"invoice");
            return response;
        } catch (error) {
            setmessage(error.message);
        }
      }
    
      const AddSplitInvoice = async function (projectId=null, total) {
        try {
          var data = {
            project_id: projectId,
            total: total,
            isDelete : 0,
            invSplitId:invSplitId
          }
          
          const response = await AxiosFetchData.post(`AddSplitInvoice`, data).refreshToken(Navigate,"invoice");
       }catch (error) {
         setmessage(error.message);
         setErrorType('error')
       }
      }
    
      const fetchData =  async () => {
        try {
          
           const response = await AxiosFetchData.get(`GetAllInvoiceV3/${id}`).refreshToken(Navigate,"invoice");
           if(response){
         
              setRoleAccess(response.roleaccess); 
              const rowsWithRowNumbers = response.data.map((row, index) => ({
                ...row,
                rowNumber: index + 1, 
                
              }));
        
              setRows(rowsWithRowNumbers);
            }
        } catch (error) {
          setmessage(error.message);
          setErrorType('error')
        }
      };

      function GetStatus(){
          axios.get(`${apiUrl}/api/GetStatusInvoice`)
          .then((response) => {
            const transformedOptions = response.data.map((item) => ({
              label: `${item}`,
              value: item,
            }));
            setStatusList(transformedOptions);
          })
          .catch((error) => {
            console.error('Error fetching category data:', error);
          });
           
      }
      
      async function  handlePrintInvoice(id, projectId, splitInvId){
        try{
           
          var response = await AxiosFetchData.get(`getInvoiceV3/${id}/${splitInvId}`).refreshToken(Navigate,"invoice");
          setAnchorEl(false)
          if(response){
              setTipe("invoice");
              GetTreeView(response.data);
              setProductList(response.data);
      
              response.data.resp.tax =response.data.quotation.tax
              setDataInvoice(response.data.resp);
            
              setRet(response.data.resp.retention == null ? 0 :response.data.resp.retention )
             
              setCustomer(response.data.customer);
              setHtml(result);
              setTotal(totalInvoice);
       
              if(response.data.resp.deskripsi == "RETENTION"){
                  let deskripsi = rows.filter((item)=>item.deskripsi != 'RETENTION' && item.project_id == projectId);
                  response.data.print.deskripsi = deskripsi.length > 0 ? deskripsi[0].deskripsi : "";
                  mainPrint = new RetentionPrint(id)
              }else{
                response.data.resp.due_date = response.data.resp.retention_due_date;
                response.data.resp.date = response.data.resp.tanggal;
                response.data.resp.payment_term = response.data.resp.paymenttermname + '-';
              }
      
              setContent({__html: mainPrint.printInvoiceExisted(`${result}`, response.data.customer, response.data.resp, response.data.resp.retention, response.data.print.deskripsi)});
            
          }
          setPrint(true);
        }catch(error){
          setmessage(error.message);
          setErrorType('error')
        }
          
      }
      
      
      function GetTreeView(data)
      {
          var no =1;
          for(let i = 0; i < data.data.length; i++){
                 
                  result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                              <td>&nbsp;</td>`
      
                              if(data.data[i].part_no){
                                  result +=  `<td>${no++}.</td>`
                              }else{
                                  result += `<td>&nbsp;</td>`
                              }
                             
                    result += `<td>${data.data[i].part_no ? data.data[i].part_no : ""}</td>
                              <td>${ data.data[i].descriptions ? data.data[i].descriptions.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''}</td>
                              <td>${data.data[i].newqty ? data.data[i].newqty : ""}</td>
                               <td>${data.data[i].unit_name ? data.data[i].unit_name : ""}</td>
                              <td>${data.data[i].price ?  Helper.formatAsCurrency(data.data[i].price) : ""}</td>
                             
                              <td>${(data.data[i].newqty && data.data[i].price) ?  Helper.formatAsCurrency(data.data[i].newqty * data.data[i].price) : ""}</td>
                      </tr>`
                  if(data.data[i].newqty && data.data[i].price){
                      totalInvoice += data.data[i].newqty * data.data[i].price
                  }
      
                  recursive(data.data[i].subChild);
               
                  nbsp ="";
             
          }
        
      }

    function recursive(data)
    { 
        if( data.length > 0){
            
            nbsp += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
            for(let i = 0; i < data.length; i++){
            
                    result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>${nbsp}${data[i].part_no ? data[i].part_no : ""}</td>
                                <td>${nbsp}- ${data[i].descriptions.replace(/(?:\r\n|\r|\n)/g, '<br>')}</td>
                                <td>${data[i].newqty ? data[i].newqty : ""}</td>
                                  <td>${data[i].unit_name ?  data[i].unit_name : ""}</td>
                                <td>${data[i].price ? Helper.formatAsCurrency(data[i].price) : "-"}</td>
                              
                                <td>${(data[i].newqty && data[i].price) ? Helper.formatAsCurrency((data[i].newqty * data[i].price)) : ""}</td>
                            </tr>`
    
                            if(data[i].newqty && data[i].price){
                                totalInvoice += data[i].newqty * data[i].price
                            }
                    
                            recursive(data[i].subChild);
            }
            
        }
       
    }
     
    
    async function  handlePrintKwitansi(id,projectId, splitInvId){
      try{
      
        const response = await AxiosFetchData.get(`GetInvoiceV3/${id}/${splitInvId}`).refreshToken(Navigate,"invoice");
        setAnchorEl(false)
        if(response){
            setTipe("kwitansi")
        
            GetTreeView(response.data);
            setProductList(response.data);
            response.data.resp.tax =response.data.quotation.tax
            setDataInvoice(response.data.resp);
           
            setRet(response.data.resp.retention == null ? 0 : response.data.resp.retention)
            setCustomer(response.data.customer);
            setHtml(result);
            setTotal(totalInvoice);
            if(response.data.resp.deskripsi == "RETENTION"){
              mainPrint = new RetentionPrint(id)
            }
            setContent({__html: mainPrint.printKwitansi(`${result}`, response.data.customer, response.data.resp, response.data.resp.retention)});
           
        }
        setPrint(true);
      }catch(e){
        setmessage(e.message)
        setErrorType('error')
      }
        
    }

    const columns = [
      { field: 'rowNumber', headerName: 'No.', width: 50 },
      { field: 'customername', headerName: 'Customer', width: 250 },
      { field: 'subject', headerName: 'Project Name', width: 250 },
      { field: 'kode', headerName: 'Code', width: 280 },
      { field: 'tanggal', headerName: 'Date', width: 100 },
      { field: 'persentase', headerName: 'Inv(%)', width: 80 },
      { field: 'total', headerName: 'Total', width: 100, valueGetter:({ value }) => value && Helper.formatAsCurrency(value)  },
      { field: 'deskripsi', headerName: 'Description', width: 150, valueGetter: ({value, row}) => {
        if(row.deskripsi == "RETENTION"){
            return `${row.deskripsi} (${row.retention || 0})%`;
        }
       
      }},
    
      {
        field: 'actions',
        headerName: 'Actions',
        width: 180,
        renderCell: (params) => (
          <>
          <Button
            id={"basic-button" + params.row.rowNumber}
            aria-controls={open ? 'basic-menu' + params.row.rowNumber : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
           
            onClick={(evt) => handleClick(evt, params.row)}
          >
            <MoreVertIcon sx={{ fontSize: 30 }}/>
          </Button>
     
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
             <MenuItem     onClick={() => handleEdit(selectedData.id, selectedData.split_invoice_id,selectedData.deskripsi)} >EDIT</MenuItem>
            {/* <MenuItem  disabled = {selectedData.deskripsi == "RETENTION" ? true : false}   onClick={() => handleEdit(selectedData.id, selectedData.split_invoice_id)} >{selectedData.lastId=='last' ? "EDIT" : "DETAIL"}</MenuItem> */}
            <MenuItem  onClick={() => handlePrintInvoice(selectedData.id, selectedData.project_id, selectedData.split_invoice_id)} >PRINT INVOICE</MenuItem>
            <MenuItem  onClick={() => handlePrintKwitansi(selectedData.id, selectedData.project_id, selectedData.split_invoice_id)} >PRINT KWINTASI</MenuItem>
            {/* <MenuItem  disabled={selectedData.status  === "Unpaid" ? true :false}  onClick={() => {
              setproductopen(true);
              setInvoiceId(selectedData.id)
              handleClose();
            }} >UPLOAD DOCUMENT/IMAGE </MenuItem> */}
          </Menu>
          <Bindcomponent component='ConfirmationButton' classname='btn btn-danger' text="Do you want delete this data?" type="button"  title="Delete"    disabled={roleAccess.DELETE == true ? (params.row.lastId =='last' ? false : true) : !roleAccess.DELETE}  onClick={() => handleDelete(params.row.id, params.row.rev, params.row.split_invoice_id)} >
              <DeleteIcon sx={{ fontSize: 15 }}/> Delete   
          </Bindcomponent>
         
          </>
          
        ),
    
      },
    ];
     
    const columnsSplit = [
        {
            field: 'actions3',
            headerName: '',
            //width: 50,
             flex: 1,
            renderCell: (params) => 
            (
                 <>
                <button className='btn btn-primary' title='Edit' fullWidth width={"100%"} onClick={(e)=>{
                    var isExist = rows.filter(row => row.split_invoice_id == params.row.id)
                    if(isExist.length > 0) {
                        setmessage('Cannot be edited, because the invoice has been issued' )
                        setErrorType('error')
                        return;
                    }
                    setInvSplitId(params.row.id)
                    setName(params.row.name)
                    setsplitInvTotal(params.row.total)
                 //   alert(params.row.rowNumber)
                    setRowNumber(params.row.rowNumber)
                    setOpenSplit(true);
                }} 
                disabled={!roleAccess.UPDATE}> <ModeEditIcon  sx={{ fontSize: 15 }}/></button> 
                &nbsp;
                <ConfirmationButton classname='btn btn-danger' text="Do you want delete this data?" type="button"  title="Delete"  disabled={!roleAccess.DELETE}  onClick={() => handleDeleteSplit(params.row.project_id, params.row.id)} >
                <DeleteIcon sx={{ fontSize: 15 }}/> 
                   </ConfirmationButton>
                   </>
            ),
          },
        
        { field: 'rowNumber', headerName: 'No.', width: 80, flex: 1  },
        { field: 'kode', headerName: 'Prefix.', width: 80, flex: 1  },
        { field: 'total', headerName: 'Total', width: 400, flex: 1, valueGetter:({ value }) => value && Helper.formatAsCurrency(value)   },
        {
            
            renderCell:(param) =>(
                <button className='btn btn-success' onClick={(e) => AddProjectData(param.row.id)} disabled={!roleAccess.CREATE}>+ Invoice</button> 
            )
        },
        
          
    ]

    const [filterModel, setFilterModel] = useState({
      items: [],
      quickFilterExcludeHiddenColumns: true,
      quickFilterValues: [''],
    });
    
    const [columnVisibilityModel, setColumnVisibilityModel] =useState({});
    // end table
    
    function AddProjectData(invSplitId) {
      const total = rowsSplit.reduce((acc, o) => acc + parseInt(o.total), 0)
      if(total !== totalPo){
        setmessage("Total value still not the same with total project value, please add more split invoice")
        setErrorType("error")
        return;
      }
      Navigate(`/AddInvoiceV3/${id}/${invSplitId}${Helper.SetReturnUrl()}`);
    
    }
    
    const handleDelete = async (projectId,rev,splitInvId) => {
     
      try {
        var data ={
            id:projectId,
            rev : rev,
            split_invoice_id : splitInvId
        }
        const response = await AxiosFetchData.post(`DeleteInvoiceV3`, data).refreshToken(Navigate,"invoice");
       
        if(response){
          await fetchData();
          setmessage(response.data)
          setErrorType('errorlog')
        }
        
      } catch (error) {
        setmessage(error.message)
        setErrorType('errorlog')
      }
    //}
    };

    const handleDeleteSplit = async (projectId,splitInvId) => {
        try {
           var data ={
               project_id:projectId,
               
               split_invoice_id : splitInvId
           }
           const response = await AxiosFetchData.post(`DeleteSplitInvoiceV3`, data).refreshToken(Navigate,"invoice");
          
           if(response){
             await fetchData();
             InitialSplitInvoice(totalPo);
             setmessage(response.data)
             setErrorType('errorlog')
           }
           
         } catch (error) {
           setmessage(error.message)
           setErrorType('errorlog')
           //console.error('Error deleting project:', error);
         }
       //}
       };
    
    
    const handleEdit = (projectId,splitInvId, type) => {
    
      //Navigate(`/EditInvoice/${projectId}?ReturnUrl=InvoiceList/${id}?ReturnUrl=ListPOEng`);
      if(type!="RETENTION"){
        Navigate(`/EditInvoiceV3/${projectId}/${splitInvId}/${Helper.SetReturnUrl()}`);
        return;
      }
      Navigate(`/EditInvoiceRetention/${projectId}/${splitInvId}/${Helper.SetReturnUrl()}`);
    };

    const StatusList = ({data}) => {
        
        return (
            <FormControl fullWidth>
            <Select
                value={data.status}
                id="demo-multiple-name"
                labelId="demo-simple-select-label"
            
                label="Status"
                disabled={!roleAccess.UPDATE}
                onChange={(evt) => handleSelectedStatus(evt, data)}
           
          >
            {statusList.map((name) => (
              <MenuItem
                key={name.value}
                value={name.value}
                
              >
                {name.label}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
        );
      };

    const openPopupAndPrintPo = (data) => {
          
        let element = document.getElementById('modalcontent');
        if(dataInvoice.deskripsi == "RETENTION"){
          mainPrint = new RetentionPrint('')
        }
        
        var popup = window.open('', 'PRINT', 'height=400,width=400');
        if(tipe=="invoice"){
            
            popup.document.write(mainPrint.printInvoiceExisted(html, customer, dataInvoice,ret,dataInvoice.deskripsi).replace('50px','15px').replaceAll("visible","hidden"));
            // popup.document.write(mainPrint.printInvoice(html, customer, dataInvoice,ret).replace('position: relative','position: fixed').replace('</header><br><br>','</header><br><br><br><br><br><br>'));
            element.innerHTML =  mainPrint.printInvoiceExisted(html, customer, dataInvoice,ret,dataInvoice.deskripsi).replaceAll("hidden","visible");
           
          }else{
            mainPrint = new MainPrint()
            popup.document.write(mainPrint.printKwitansi(html, customer, dataInvoice,ret).replace('position: relative','position: fixed').replace('</header><br><br>','</header><br><br><br><br><br><br>'));
            element.innerHTML =  mainPrint.printKwitansi(html, customer, dataInvoice,ret);
        }
       
        popup.print(); 
        popup.close();
       
         
      }

    async function  handleSelectedStatus(event, data){
       try{
        var data = {
          status : event.target.value,
          id : data.id
     }
         const response = await AxiosFetchData.post(`UpdateStatusInvoice`, data).refreshToken(Navigate,"invoice")
         if(response){
             await fetchData();
             setmessage(response.data)
         }
       }catch(e){
          setmessage(e.message)
          setErrorType('errorlog')
       }
       
      }
    
      async function handleRetentionClose(event, reason){
        if(rows.length == 0){
          if(reason !== "backdropClick"){
            setOpenRetention(false);
          }
        }else{
          setOpenRetention(false);
        }
      }
    
      async function handleSplitClose(event, reason){
       
      
        if(rowsSplit.length == 0){
          if(reason !== "backdropClick"){
            setOpenSplit(false);
          }
        }else{
         
            setOpenSplit(false);
        }

         setName('')
         setsplitInvTotal(1)
        setInvSplitId(null)
         
      }

    async function handleSaveRetention(event){
        event.preventDefault();
        //setOpenRetention(false);
        setIsNullRetention(false)
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        
        var data = {
                  project_id : id,
                  retensi : formJson.txtRtn,
                  period_number :  formJson.txtPeriod,
                  period : formJson.optPeriod,
                  isDelete : 0
                }
              
        try{
              var response = await AxiosFetchData.post(`UpdateRetentionV3`, data).refreshToken(Navigate,"invoice")
              setmessage(response.data);
              await fetchData();
            }catch(e){
              setmessage(e.message);
              setErrorType('errorlog')
            }
               
            handleRetentionClose();
    }

    async function handleSaveSplitInv(event){
        event.preventDefault();
        
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        
        const total = rowsSplit.reduce((acc, o) => acc + parseInt(o.total), 0)
       // console.log(totalPo)
      
       if(invSplitId){
            var total2 = rowsSplit.filter((val)=> val.id !== invSplitId).reduce((acc, o) => acc + parseInt(o.total), 0)
            if((parseFloat(total2) + parseFloat(splitInvTotal)) > parseFloat(totalPo)){
                setmessage("Total split invoice cannot be greater than total project");
                setErrorType("error")
                return;
            }
       }else{
       // alert(total + splitInvTotal)
            if(parseFloat(total) + parseFloat(splitInvTotal)  > parseFloat(totalPo)){
                setmessage("Total split invoice cannot be greater than total project");
                setErrorType("error")
                return;
            }
       }
      
        try{
             await AddSplitInvoice(id, splitInvTotal)
           //  var response = await AxiosFetchData.post(`AddSplitInvoice`, data).refreshToken(Navigate,"invoice")
             if(invSplitId){
                setmessage("Data Susccesfully Updated");
             }else{
                setmessage("Data Susccesfully Added");
             }
             setErrorType('')
             InitialSplitInvoice(totalPo);
            }catch(e){
              setmessage(e.message);
              setErrorType('errorlog')
            }
               
            handleSplitClose();
    }

    function handleUploadDialogClose(){
        setproductopen(false)
        
    }

    return {message,setmessage,errorType,setErrorType,handleSelectedProject,selectedOptionProject,setOpenSplit,roleAccess,GetRetention,setRetensi,setPeriodNumber,setPeriod,setOpenRetention,openRetention,handleRetentionClose,handleSaveRetention,isNullRetention,retensi,periodNumber,period,openSplit,handleSplitClose,handleSaveSplitInv,invSplitId,rowsSplit,rowNumber,splitInvTotal,setsplitInvTotal,columnsSplit,columns,rows,print,setPrint,content,openPopupAndPrintPo,result,productopen,handleUploadDialogClose,invoiceId, projectList,filterModel,setFilterModel,columnVisibilityModel,setColumnVisibilityModel,paymentOpen,setPaymentOpen}
}